/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-12-15 14:30:43
 */
import ColumnTypes from "@/utils/ColumnTypes";

const colonelActivitySquare = {
    key: 'colonelActivitySquare',
    label: '商品信息',
    type: ColumnTypes.channelShopCell,
    minWidth: '400',
    fixed: 'left'
};
const todoPromote = {
    key: 'todoPromote',
    label: '商品推广状态',
    type: ColumnTypes.promotionCell,
    minWidth: '140'
}
const stock_num = {
    key: 'stock_num',
    label: '推广周期',
    startTime: 'promotion_start_time',
    endTime: 'promotion_end_time',
    type: ColumnTypes.extensionTimeCell,
    minWidth: '180'
}
const origin_activity_name = {
    key: 'origin_activity_name',
    label: '归属活动',
    copy_id: 'origin_activity_id',
    notes: '活动ID',
    type: ColumnTypes.cooperationInfoCell,
    minWidth: '160'
}
const service_rate = {
    key: 'service_rate',
    label: '服务费率',
    type: () => import('./components/ksTableCell/serviceRateCell'),
    minWidth: '200'
}
const commission_rate = {
    key: 'commission_rate',
    label: '佣金率',
    minWidth: '200',
    type: () => import('./components/ksTableCell/serviceRateCell'),
}
const fail_reason = {
    key: 'fail_reason',
    label: '报名失败原因',
    minWidth: '120',
    type: ColumnTypes.TextCell,
}
const operations = {
    key: 'operations',
    label: '操作',
    minWidth: '120',
    fixed: 'right',
    type: ColumnTypes.ButtonsCell,
    align: 'right'
}

export const columns_success = [
    colonelActivitySquare,
    todoPromote,
    stock_num,
    origin_activity_name,
    service_rate,
    commission_rate,
    operations
]

export const columns_fail = [
    colonelActivitySquare,
    todoPromote,
    stock_num,
    origin_activity_name,
    service_rate,
    commission_rate,
    fail_reason,
    operations
]